import { groupBy, invert } from 'lodash';

export const RULE_TARGET_TO_TYPE = {
    targetBuildingTypes:  'BuildingType',
    targetBusinessTypes:  'BusinessType',
    targetClients:        'Client',
    targetEquipmentTypes: 'EquipmentType',
    targetSites:          'Site',
    targetSystemTypes:    'SystemType'
};

export const TYPE_TO_RULE_TARGET = invert(RULE_TARGET_TO_TYPE);

/**
 * Returns TRUE if the rulet target type is already selected. This is a custom
 * function because rule targets types are tracked by `nodeId`, not `id`.
 */
export function isTargetSelected(item, selectedItems) {
    return selectedItems.some(({ nodeId }) => nodeId === item.nodeId);
}

/**
 * This splits a target field's array of values into two different values based
 * upon the item type and the Rule property that store the respective values.
 *
 * Example:
 *
 * A field value of:
 *
 *   [{ name: 'abc', type: 'BusinessType' }, { name: 'def', type: 'Client' }]
 *
 * Would get mapped to:
 *
 *   { targetBusinessTypes: [{ name: 'abc', type: 'BusinessType' }] },
 *   { targetClients: [{ name: 'abc', type: 'Client' }] },
 *
 */
export function targetChangeHandler(callback, defaultValues = {}) {
    return (event) => {
        const { value } = event.target;
        const groupedValues = groupBy(value, 'type');
        const newValues = { ...defaultValues };
        Object.entries(groupedValues).forEach(([type, value]) => {
            const ruleTargetType = TYPE_TO_RULE_TARGET[type];
            newValues[ruleTargetType] = value;
        });
        callback(newValues);
    };
}

/**
 * The Rules API cannot store rule target types by their `id` so the `id` value
 * must be mapped to the `nodeId` property.
 */
export function optionsTransform(values) {
    return (values || []).map(({ id, ...item }) => ({
        ...item,
        nodeId: item.nodeId || id
    }));
}

export function siteOptionsTransform (values) {
    let sortedValues = [];
    if (values && values.length !== 0) {
        sortedValues = values.sort((a, b) => {
            if (a.clientName === b.clientName) {
                return a.name > b.name ? 1 : -1;
            }
            return a.clientName > b.clientName ? 1 : -1;
        });
    }

    return (sortedValues || []).map(({ id, ...item }) => ({
        ...item,
        nodeId: item.nodeId || id,
        name:   item.clientName + '/' + item.name || item.name
    }));
}
